import axiosAPI from './axios'
import { GET_FEATURES } from './endpoints'

interface FeatureFlagResponse {
  flags: Array<{
    name: string
    isActive: boolean
  }>
}

export const fetchFeatureFlags = async (): Promise<Record<string, boolean>> => {
  try {
    const response = await axiosAPI.get<FeatureFlagResponse>(GET_FEATURES())
    const { flags } = response.data
    
    const flagsObject: Record<string, boolean> = {}
    flags.forEach(flag => {
      flagsObject[flag.name] = flag.isActive
    })
    
    return flagsObject
  } catch (error) {
    console.error('Failed to fetch feature flags:', error)
    return {}
  }

  // return {
  //   'enable-polls': true
  // }
}
